const template = {
  materialoptions: [
    {
      name: 'shirt_nike',
      title: 'shirt nike material',
      type: 'single',
      object: [
        'T894230_seams',
        'T894230_stripes',
        'T894230_neck_back',
        'T894230_collar',
        'T894230_sleeves',
        'T894230_back',
        'T894230_front'
      ],
      visible: '894230-010',
      options: [
        {
          name: '894230-010',
          title: 'Shirt',
          basedon: 'shoe',
          payload: {
            glossiness: 0.16,
            // diffuseColor: [0.84, 0.25, 0.004],
            specularColor: [0.03, 0.03, 0.03],
            diffuseTexture: {
              liquid: {
                prodID: '894230-010'
              },
            },
            normalTexture: {
              path: 'nikepoc/assets/textures/894230-normal.png',
              level: 5.2
            },
            specularGlossinessTexture: {
              path: 'nikepoc/assets/textures/SpecGloss_nike.png',
              level: 1.0
            }
          },
          icon: '/data/appliance/textures/ConcreteNew0012_2_S.jpg'
        }
      ]
    },
  ],
  liquid: [
    {
      title: 'Shirt Nike',
      name: 'shirt_nike',
      materialname: 'shirt_nike',
      materialoption: '894230-010',
      channel: 'diffuseTexture',
      prodID: '894230-010',
      keygroups: [3,5,7,9,11],
      options: {
        productid: {
          key: 'prodID',
          value: [
            '894230-010',
            '894230-057',
            '894230-412',
            '894230-463',
            '894230-464',
            '894230-739',
            '894230-815'
          ],
          default: '894230-010',
        },
        location: {
          key: 1,
          value: [
            { value: 'b', text: 'Both sides'},
            { value: 'r', text: 'Right'},
            { value: 'l', text: 'Left'},
          ],
          default: 'b',
        },
        type: {
          key: 0,
          value: [
            { value: 'BASIC', text: 'No personalization'},
            { value: 'LeftChest', text: 'Crest'},
            { value: 'CenterFront', text: 'Center Front Sponsor'},
            { value: 'Sleeves', text: 'Sleeve Sponsor'},
            { value: 'PlayerName', text: 'Player Name'},
            { value: 'PlayerNumber', text: 'Player Number'},
          ],
        },
        imageurl1: {
          key: 2,
          value: 'https://pixnetiq.com/Nike/nike-team-logo.jpg',
          default: 'https://pixnetiq.com/Nike/nike-team-logo.jpg',
        },
        text1: {
          key: 4,
          value: 'Mike',
          default: 'Mike',
        },
        text2: {
          key: 5,
          value: '9',
          default: '9',
        },
        fontcolor: {
          key: 9,
          value: [
            { text: '39Y', value: '1c451d' },
            { text: '00A', value: '252525' },
            { text: '00L', value: '7dd28e' },
            { text: '01B', value: '8da0a2' },
            { text: '01V', value: '9db1b7' },
            { text: '06F', value: '2d3741' },
            { text: '09T', value: 'a2a099' },
            { text: '10A', value: 'ffffff' },
            { text: '11K', value: 'faf7ed' },
            { text: '2AQ', value: '2b2723' },
            { text: '30R', value: '188411' },
            { text: '3GE', value: '3df230' },
            { text: '3GU', value: '7dffae' },
            { text: '43J', value: '0d59ff' },
            { text: '44A', value: '07a9c1' },
            { text: '44B', value: '17243c' },
            { text: '45B', value: '424B6D' },
            { text: '47N', value: '65c0ff' },
            { text: '4CA', value: '0c1115' },
            { text: '51L', value: '4b2a70' },
            { text: '61L', value: '73334d' },
            { text: '65N', value: 'c6002e' },
            { text: '67P', value: '58072f' },
            { text: '68X', value: 'db1dd6' },
            { text: '6CD', value: 'ff0455' },
            { text: '6DQ', value: 'e10557' },
            { text: '70N', value: 'b4a051' },
            { text: '71R', value: 'ccff26' },
            { text: '76I', value: 'ffa30d' },
            { text: '77A', value: 'b5a66a' },
            { text: '79H', value: 'ffcb23' },
            { text: '81C', value: 'ff6291' },
            { text: '81J', value: 'ff4819' }, 
          ],        
          default: '1c451d',
        },
        imageurl2: {
          key: 3,
          value: 'https://pixnetiq.com/Nike/nike-team-logo.jpg',
          default: 'https://pixnetiq.com/Nike/nike-team-logo.jpg',
        },
        imageurl3: {
          key: 6,
          value: 'https://pixnetiq.com/Nike/nike-team-logo.jpg',
          default: 'https://pixnetiq.com/Nike/nike-team-logo.jpg',
        },

      },
      relations: {
        BASIC: ['type'],
        TXT: ['location','type','text1','text2','truetypefont','fontcolor'],
        // LTR: ['location','type','text1','wilcomfont','fontcolor'],
        // IMG: ['location','type','imageurl'],
        LeftChest: ['type','imageurl1'],
        Sleeves: ['location', 'type','imageurl3'],
        CenterFront: ['type','imageurl2'],
        PlayerName: ['type','text1','fontcolor'],
        PlayerNumber: ['type','text2','fontcolor'],
        // EMB: ['location','type','embroideryurl','embroiderycolors']
      }
    }
  ],
  liquifire: {
    sink: {
      format: "jpg",
      quality: 90,
      nocache: false
    },
    baseurl: 'https://niketeamsport.liquifire.com/NTS',
    chain: 'file:Nike/main-webgl.chain',
    headers: 'addheader=key[Access-Control-Allow-Origin],value[*]',
    keys: [

    ],
    options: [
    ]
  },
  visibilitysingle: [
    {
      title: 'Shirt',
      visible: true,
      name: 'shirt',
      objects: [
        'body',
        'button_stitching',
        'buttons',
        'collar_stand',
        'labels',
        'placket',
        'sleeves',
        'stitches'
      ]
    },
    {
      title: 'Buttons',
      visible: true,
      name: 'buttons',
      objects: [
        'button_stitching',
        'buttons'
      ]
    }
  ],
  visibilitygroup: [
  ],
  materials: [
    {
      name: 'shoe',
      library: 'empty',
      payload: {
        type: 'PBRSpecularGlossinessMaterial',
        diffuseColor: [1.0, 1.0, 1.0],
        glossiness: 1.0,
        specularColor: [0.0, 0.0, 0.0]
      }
    }
  ],
  views: [
    {
      title: 'Start',
      name: 'start',
      payload: {
        alpha: -90,
        beta: 90,
        radius: 1.3,
        lowerRadiusLimit: 0.5,
        upperRadiusLimit: 1.8,
        upperBetaLimit: 140,
        wheelPrecision: 0.1,
        wheelDeltaPercentage: 0.02,
        maxZ: 60,
        minZ: 0.12,
        target: [0, 1.3, 0],
        fov: 45
      }
    },
    {
      title: 'Front',
      name: 'front',
      payload: {
        alpha: -1.58,
        beta: 1.49,
        radius: 0.5,
        fov: 45
      }
    },
    {
      title: 'Side',
      name: 'side',
      payload: {
        alpha: -3.14,
        beta: 1.49,
        radius: 0.5,
        fov: 45
      }
    },
    {
      title: 'Sink',
      name: 'sink',
      payload: {
        alpha: -1.58,
        beta: 0.5,
        radius: 0.5,
        fov: 45
      }
    }
  ],
  player: [
    {
      name: 'avoidunder',
      library: 'avoidunder',
      payload: {
        orbit_constraint_pitch_down: -1.5,
        orbit_constraint_zoom_in: 5,
        orbit_constraint_zoom_out: 25,
        transparent: 1
      }
    }
  ],
  background: [
    {
      name: 'white',
      library: 'white',
      payload: {
      }
    }
  ],
  environment: [
    {
      name: 'softgeneric',
      library: 'empty',
      payload: {
        environmentmap: 'environment/Assembled_environment_004.hdr',
        exposure: 0.8,
        contrast: 1.0,
        clearcolor: [1, 1, 1]
      }
    },
    {
      name: 'softvignette',
      library: 'empty',
      payload: {
        environmentmap: 'environment/Assembled_environment_004.hdr',
        exposure: 0.9,
        contrast: 1.0,
        clearcolor: [1, 1, 1],
        vignetteEnabled: true,
        vignetteWeight: 4,
        vignetteCameraFov: 0.4
      }
    }
  ],
  postprocessing: [
    {
      name: 'ssao',
      library: 'empty',
      payload: {
        ssaoRatio: 1.0,
        blurRatio: 1.0,
        radius: 0.3,
        samples: 32,
        maxZ: 10,
        minZAspect: 500
      }
    }
  ],
  lighting: [
    {
      name: '2point',
      library: 'empty',
      payload: {
        lights: [
          {
            name: 'light1',
            vector: [-1, -1.5, 1.2],
            pos: [-6, 6, -6],
            intensity: 1.0,
            shadowMinZ: 3,
            shadowMaxZ: 50
          },
          {
            name: 'light3',
            vector: [1, -1, -1],
            pos: [6, 6, 6],
            intensity: 0.8
          },
          {
            name: 'light2',
            vector: [0, -1, 0],
            pos: [0, 25, 0],
            intensity: 0.0,
            includedOnlyMeshes: ['ground']
          }
        ],
        shadowgenerator: {
          lightname: 'light1',
          size: 2048,
          bias: 0.001
        }
      }
    },
    {
      name: 'nike',
      library: 'empty',
      payload: {
        lights: [
          {
            name: 'light1',
            vector: [0.2,-1,0.5],
            pos: [-6, 6, -6],
            intensity: 1.0,
            shadowMinZ: 3,
            shadowMaxZ: 50
          },
          {
            name: 'light3',
            vector: [0,-1.0,-0.9],
            pos: [6, 6, 6],
            intensity: 2
          },
        ],
        shadowgenerator: {
          // lightname: 'light1',
          // size: 2048,
          // bias: 0.001
        }
      }
    }
  ],
  annotations: [
  ],
  textoptions: [
    {
      name: 'groundtext',
      title: 'Type on ground',
      scenematerial: 'groundtext',
      text: 'Klaas is awesome',
      payload: {
        size: {width: 512, height: 512},
        font: '32px arial',
        canvasColor: 'rgba(255, 255, 255, 1.0)',
        textColor: 'rgba(120, 120, 120, 1)',
        channels: {
          albedoTexture: null
        }
      }
    }
  ],
  labels: [

  ],
  keygroups: [
    {
      basenumber: 3,
      sequential: 1,
      liquid: {}
    },
    {
      basenumber: 5,
      sequential: 2,
      liquid: {}
    },
    {
      basenumber: 7,
      sequential: 3,
      liquid: {}
    },
    {
      basenumber: 9,
      sequential: 4,
      liquid: {}
    },
    {
      basenumber: 11,
      sequential: 5,
      liquid: {}
    }
  ]
}

export default template
